module.exports = __webpack_public_path__ + "static/noticias-11--0c9b49e324fad61125c6989add88ab08.png";